import React from "react";
import {
  Layout,
  Paragraph,
  Spacing,
  Title,
  withFeedback,
  WithFeedbackProps,
} from "@sicredi/react";
import "./styles.scss";
import { ShowAccreditedDentalOffices } from "#/components/ShowAccreditedDentalOffices";

type Props = Pick<WithFeedbackProps, "setError" | "setException">;

export const AccreditedDentalOffices: React.FC<Props> = () => {
  return (
    <Layout>
      <Layout.Container>
        <Layout.Content>
          <Title as="h1">Rede credenciada SulAmérica</Title>
          <Spacing appearance="x-large" />
          <Paragraph>
            Encontre a rede credenciada mais próxima de você.
          </Paragraph>
          <Spacing appearance="large" />
          <ShowAccreditedDentalOffices />
        </Layout.Content>
      </Layout.Container>
    </Layout>
  );
};

export default withFeedback(AccreditedDentalOffices);
